import React from 'react';
import { ButtonPillView } from '../Buttons/ButtonPillView';
import styles from './Calculator.module.css';
import { THandleButtonClick } from './utils/types';

type TCalculatorSubmitButtonProps = {
    isEnabled: boolean;
    label: string;
    handleClick: THandleButtonClick;
    parentStyleNames?: string[];
    /** Design version of the owning widget. */
    version: number | undefined;
};
const CalculatorSubmitButton = React.memo(({ isEnabled, label, handleClick, parentStyleNames, version }: TCalculatorSubmitButtonProps) => {
    return (
        <div className={styles.calculatorButtonStyled}>
            <ButtonPillView
                styleName="calculatorSubmitButton"
                parentStyleNames={parentStyleNames}
                hierarchy="primary"
                position="floating"
                size={'large'}
                label={label ?? ''}
                onClick={handleClick}
                isDisabled={!isEnabled}
                maxWidth="100%"
                version={version}
            />
        </div>
    );
});
export { CalculatorSubmitButton };
